import { CSSProperties } from 'react';
import { FCC } from '~/utils/types';

type Props = {
  gap?: CSSProperties['gap'];
  direction?: CSSProperties['flexDirection'];
  alignItems?: CSSProperties['alignItems'];
  justifyContent?: CSSProperties['justifyContent'];
  wrap?: boolean;
  style?: CSSProperties;
  className?: string;
};

export const FlexBox: FCC<Props> = ({
  children,
  gap = '1rem',
  direction = 'row',
  alignItems,
  wrap = true,
  justifyContent,
  style,
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        gap,
        flexDirection: direction,
        alignItems,
        justifyContent,
        flexWrap: wrap ? 'wrap' : 'nowrap',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
